import { createReducer } from './Reducer';
export const count = createReducer((memo) => {
    return memo + 1;
}, 0);
